import { useMemo } from 'react';
import { useSitecoreContext } from './useSitecoreContext';

const useLanguageVersions = () => {
  const { sitecoreContext } = useSitecoreContext();

  return useMemo(() => {
    if (!sitecoreContext.languageVersions) return [];

    const versions = sitecoreContext.languageVersions
      .filter((item) => item.applicableForSelector)
      .map((item) => ({
        ...item,
        label: item.languageName,
        value: item.hreflang,
        selected: false,
      }));

    return versions;
  }, [sitecoreContext.languageVersions]);
};

export default useLanguageVersions;
